export const POLYGON_COLORS = {
  HOVER: {
    FILL: "rgb(255, 184, 0)",
    STROKE: "#FFB800",
  },
  DEFAULT: {
    FILL: "rgb(0, 123, 255)",
    STROKE: "rgb(0, 123, 255)",
  },
  ACTIVE: {
    FILL: "rgba(248, 207, 0, 0.25)",
    STROKE: "rgba(248, 207, 0)",
  },
};

export const ZONE_POLYGON_COLORS = {
  DEFAULT: {
    FILL: "limegreen",
    STROKE: "limegreen",
  },
};

export const GONDOLA_COLORS = {
  HOVER: "#FFB800",
  DEFAULT: "#2563eb",
};
